import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { lazy, Suspense } from 'react';
import { createBrowserRouter, Navigate, RouterProvider } from 'react-router';
import { AuthProvider } from '@/auth/AuthProvider';
import { LinkedAccountGate } from '@/auth/LinkedAccountGate';
import { SignInCallback } from '@/auth/SignInCallback';
import { AppShell } from './AppShell';

// Pages load on demand; Plan and Maps pull in OpenLayers, Library doesn't need it.
const PlanPage = lazy(() => import('@/features/plan/PlanPage'));
const LibraryPage = lazy(() => import('@/features/library/LibraryPage'));
const MapsPage = lazy(() => import('@/features/maps/MapsPage'));
const GarminCallback = lazy(() => import('@/features/garmin/GarminCallback'));

const queryClient = new QueryClient({
  defaultOptions: { queries: { staleTime: 30_000, retry: 1 } },
});

const routes = [
  {
    element: <AppShell />,
    children: [
      { index: true, element: <Navigate to="/plan" replace /> },
      { path: 'plan', element: <PlanPage /> },
      { path: 'library', element: <LibraryPage /> },
      { path: 'maps', element: <MapsPage /> },
      // The OIDC callback lands here; AuthProvider completes the sign-in, then this moves on.
      { path: 'auth/callback', element: <SignInCallback /> },
      // Garmin Connect returns here after the user approves the link.
      { path: 'garmin/callback', element: <GarminCallback /> },
      { path: '*', element: <Navigate to="/plan" replace /> },
    ],
  },
];

const router = createBrowserRouter(routes);

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <LinkedAccountGate>
          <Suspense fallback={null}>
            <RouterProvider router={router} />
          </Suspense>
        </LinkedAccountGate>
      </AuthProvider>
    </QueryClientProvider>
  );
}
